import { render } from "./WorkflowAggregateSelectBoundedContext.vue?vue&type=template&id=3724886a"
import script from "./WorkflowAggregateSelectBoundedContext.vue?vue&type=script&lang=js"
export * from "./WorkflowAggregateSelectBoundedContext.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__